import axios from 'axios';

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 基础域名，根据实际情况修改
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('token');
    if (token) {
      // 如果token存在，添加到请求头
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    // 请求错误处理
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 获取响应数据
    const res = response.data;
    // 根据实际接口返回格式调整
    if (res.code === 200) {
      // 成功状态码，返回数据
      return res;
    } else {
      // 其他状态码，抛出错误
      console.error('接口错误:', res.message);
      return Promise.reject(new Error(res.message || 'Error'));
    }
  },
  error => {
    // 响应错误处理
    console.error('响应错误:', error);

    if (error.response) {
      // 服务器返回错误状态码
      switch (error.response.status) {
        case 401:
          // 未登录，跳转到登录页
          console.error('未登录，请重新登录');
          // 可以在这里添加跳转登录页的逻辑
          break;
        case 403:
          // 无权限
          console.error('无权限访问');
          break;
        case 500:
          // 服务器错误
          console.error('服务器错误');
          break;
        default:
          console.error(`请求错误: ${error.response.status}`);
      }
    } else if (error.request) {
      // 请求已发送但没有收到响应
      console.error('网络错误，请检查网络连接');
    } else {
      // 请求配置错误
      console.error('请求配置错误:', error.message);
    }

    return Promise.reject(error);
  }
);

export default service;
